<!-- eslint-disable sonarjs/no-duplicate-string -->
<template>
  <Sect class="SectionHowItWorks">
    <Row>
      <Column class="leftSide" :md="6">
        <Wrap class="sm">
          <h2>Kaip tai veikia?</h2>
          <p>
            Tiek Lietuvos gyventojai, tiek verslo atstovai, ar kiti juridiniai asmenys, gali įsigyti nutolusių „Saulės bendruomenės“ elektrinių dalį ir tapti gaminančiais vartotojais.
          </p>
          <p>
            Rezervacijos proceso metu klientai kviečiami pasrinkti jų poreikius atitinkančią nutolusios saulės elektrinės dalį ir ją rezervuoti. Sužinoti, kokio dydžio saulės elektrinės dalį palankiausia rezervuoti jums, galite
            <Route :to="{ name: 'Index', hash: '#Calculator' }">
              išmaniosios skaičiuoklės
            </Route>
            pagalba.
          </p>
          <p>
            Rezervavę nutolusios saulės elektrinės dalį, statybos darbų progresą, dokumentus bei kitą informaciją galėsite pasiekti tiesiog prisijungę prie savo paskyros.
          </p>
          <p>
            „Saulės bendruomenės“ komanda nuolat stebi elektrinės veikimą ir taip užtikrina, kad projektas veiktų pilnu galimu pajėgumu ištisus metus.
          </p>
        </Wrap>
      </Column>
      <Column class="rightSide" :md="6" />
    </Row>
  </Sect>
</template>

<script>

export default {
}
</script>

<style lang="scss">
.Sect.SectionHowItWorks {
  color: $white;

  // .Btn {
  //   border: 1px solid $white;
  //   color: $white;
  // }

  > .Row {
    flex-direction: row;

    > .Column {
      display: flex;
      padding: 5rem 1rem;

      > .Wrap {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        justify-content: space-between;
      }
    }
  }

  .rightSide {
    background: url('../../../assets/aboutUs/panel-owner.jpg');
    background-position: top right;
    background-size: cover;
    color: $white;
    min-height: 20rem;
    // padding: 3rem 0 1rem;
    position: relative;
  }

  .leftSide {
    background: $black-bis;
    background-size: 40vw;
    padding: 0 2rem;
  }

  h2 {
    color: inherit;
    text-align: left;
    // font-size: 1rem;
    // @include lg {
    //   font-size: 3rem;
    // }
  }

  p {
    line-height: 1.6;
  }

  a {
    color: $blue;
  }
}
</style>
